import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
  standalone: false
})
export class PhoneFormatPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) return '-';
    
    // Eliminar espacios en blanco
    const cleaned = value.toString().replace(/\s/g, '');
    
    // Verificar si es un número internacional (empieza con +)
    if (cleaned.startsWith('+')) {
      
      // Formato para Argentina: +54 9 XXX XXX-XXXX
      // Ejemplo: +5493888321234 → +54 9 388 832-1234
      const argentinaMatch = cleaned.match(/^\+54(\d)(\d{2,4})(\d{3})(\d{4})$/);
      if (argentinaMatch) {
        const [, prefix, areaCode, part1, part2] = argentinaMatch;
        return `+54 ${prefix} ${areaCode} ${part1}-${part2}`;
      }
      
      // Formato para España: +34 XXX XXX XXX
      // Ejemplo: +34567888999 → +34 567 888 999
      const spainMatch = cleaned.match(/^\+34(\d{3})(\d{3})(\d{3})$/);
      if (spainMatch) {
        const [, part1, part2, part3] = spainMatch;
        return `+34 ${part1} ${part2} ${part3}`;
      }
      
      // Formato genérico para otros países internacionales
      const genericMatch = cleaned.match(/^(\+\d{1,3})(\d+)$/);
      if (genericMatch) {
        const [, countryCode, rest] = genericMatch;
        // Agrupar el resto en bloques de 3 dígitos para mejor legibilidad
        const formatted = rest.match(/.{1,3}/g)?.join(' ') || rest;
        return `${countryCode} ${formatted}`;
      }
    }
    
    // Si no es internacional, devolver el valor limpio con espacios cada 3 dígitos
    if (cleaned.length > 6) {
      const formatted = cleaned.match(/.{1,3}/g)?.join(' ') || cleaned;
      return formatted;
    }
    
    return cleaned;
  }

}
